export const BankAssetUrl = '/images/iban-banks/';

export const Banks = [
    {
        name: 'صادرات ایران',
        icon: 'BSI',
        color: '#4e52b2',
    },
    {
        name: 'ملت',
        icon: 'MEL',
        color: '#a41f21',
    },
    {
        name: 'تجارت',
        icon: 'TEJ',
        color: '#496fc3',
    },
    {
        name: 'ملی ایران',
        icon: 'BMI',
        color: '#a42121',
    },
    {
        name: 'سپه',
        icon: 'BSP',
        color: '#1e80bc',
    },
    {
        name: 'کشاورزی',
        icon: 'BKV',
        color: '#11503f',
    },
    {
        name: 'پارسیان',
        icon: 'PAR',
        color: '#653c1f',
    },
    {
        name: 'مسکن',
        icon: 'BMK',
        color: '#904526',
    },
    {
        name: 'رفاه کارگران',
        icon: 'REF',
        color: '#065da7',
    },
    {
        name: 'اقتصاد نوین',
        icon: 'ENB',
        color: '#802381',
    },
    {
        name: 'انصار',
        icon: 'ANS',
        color: '#862b20',
    },
    {
        name: 'پاسارگاد',
        icon: 'PAS',
        color: '#a77613',
    },
    {
        name: 'سامان',
        icon: 'SAM',
        color: '#0177BF',
    },
    {
        name: 'سینا',
        icon: 'SIN',
        color: '#a0771f',
    },
    {
        name: 'پست بانک ایران',
        icon: 'PST',
        color: '#228150',
    },
    {
        name: 'قوامین',
        icon: 'GHA',
        color: '#0d774c',
    },
    {
        name: 'توسعه تعاون',
        icon: 'BTT',
        color: '#11787e',
    },
    {
        name: 'شهر',
        icon: 'SHR',
        color: '#a00f0f',
    },
    {
        name: 'آینده',
        icon: 'AYN',
        color: '#a77516',
    },
    {
        name: 'سرمایه',
        icon: 'SAR',
        color: '#777676',
    },
    {
        name: 'دی',
        icon: 'DEY',
        color: '#0e4a53',
    },
    {
        name: 'حکمت ایرانیان',
        icon: 'hi',
        color: '#0f69b9',
    },
    {
        name: 'ایران زمین',
        icon: 'IRZ',
        color: '#7138af',
    },
    {
        name: 'کارآفرین',
        icon: 'BKA',
        color: '#41623a',
    },
    {
        name: 'گردشگری',
        icon: 'GAR',
        color: '#10a4b9',
    },
    {
        name: 'صنعت و معدن',
        icon: 'BSM',
        color: '#997739',
    },
    {
        name: 'توسعه صادرات',
        icon: 'edbi',
        color: '#27492d',
    },
    {
        name: 'خاورمیانه',
        icon: 'KHMI',
        color: '#b56c04',
    },
    {
        name: 'قرض الحسنه رسالت',
        icon: 'RES',
        color: '#0d8d96',
    },
    {
        name: 'مهر ایران',
        icon: 'MHR',
        color: '#5f850a',
    },
    {
        name: 'موسسه اعتباری ملل',
        icon: 'ASKC',
        color: '#4768d2',
    },
    {
        name: 'موسسه اعتباری نور',
        icon: 'NOR',
        color: '#3385ca',
    },
];
